import { render, staticRenderFns } from "./Parc.vue?vue&type=template&id=b5324962"
import script from "./Parc.vue?vue&type=script&lang=js"
export * from "./Parc.vue?vue&type=script&lang=js"
import style0 from "./Parc.vue?vue&type=style&index=0&id=b5324962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports